
import { Component, Vue, Prop, PropSync, Watch, Ref } from 'vue-property-decorator';
import { fdmMedicinalListEdit } from "@/api/consultation";

import { ElForm } from "element-ui/types/form";


@Component({ name: 'fourCombine-components-ProductDialog' })
export default class ProductDialog extends Vue {
  @PropSync("dialogVisible") visible!: boolean;
  @PropSync("editData") form!: Record<string, any>;
  @Prop({ default: () => [] }) readonly existingNames!: string[];

  @Ref('formRef') readonly formRef!: ElForm;

  rules = {
    productName: [
      { required: true, message: '请输入产品名称', trigger: 'blur' },
      { max: 30, message: '最多输入30个字', trigger: 'blur' },
    ],
    effect: [
      { required: true, message: '请输入功效', trigger: 'blur' },
      { max: 300, message: '最多输入300个字', trigger: 'blur' },
    ],
  };

  @Watch('editData', { deep: true })
  onEditDataChange() {
    this.initForm();
  }

  initForm() {
  }

  handleClose() {
    this.formRef?.resetFields();
    this.visible = false;
  }

  handleSubmit() {
    (this.$refs.formRef as any).validate((valid: boolean) => {
      if (valid) {
        fdmMedicinalListEdit({ ...this.form }).then((res) => {
          this.$message.success("操作成功")
          this.$emit("refreshList")
          this.handleClose();
        })
      }
    });
  }
}
